import { createIntl, createIntlCache } from 'react-intl'
import { allMessages } from './i18nProvider'
import { getSelectedLang } from './Metronici18n'

const cache = createIntlCache()

/**
 * An intl object for code that runs outside React (e.g. SweetAlert dialogs opened from event
 * handlers). It uses the same language and messages as the application's IntlProvider.
 */
export function getStandaloneIntl() {
  const locale = getSelectedLang() in allMessages ? getSelectedLang() : 'en'
  return createIntl(
    { locale, messages: (allMessages as Record<string, Record<string, string>>)[locale] },
    cache
  )
}
